<template>
  <div class="filter-text filter-free-search">
    <input
      ref="input"
      type="text"
      class="form-control"
      :class="{'i-active-filter': Boolean(modelValue) }"
      v-bind="$attrs"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      @keydown.enter.stop.prevent="$emit('submit')"
      @keydown.escape.stop.prevent="reset"
      :placeholder="$attrs.placeholder || LANG.searchFor"
      />
    <div v-if="modelValue"
      @click.prevent.stop="reset"
      class="fa5 fa-times far btn-action text-center"></div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState } from 'vuex';

export default defineComponent({
  props: {
    modelValue: {
      type: String,
      required: false,
      default: '',
    },
    initialValue: {
      type: String,
      required: false,
    },
  },
  emits: ['update:modelValue', 'reset'],
  inheritAttrs: false,
  watch: {
    initialValue(value) {
      if (typeof value !== 'string') return;
      this.$emit('update:modelValue', value);
    },
  },
  created() {
    if (typeof this.initialValue !== 'string') return;
    this.$emit('update:modelValue', this.initialValue);
  },
  computed: {
    ...mapState(['LANG']),
  },
  methods: {
    reset() {
      this.focus();

      this.$emit('update:modelValue', '');
      this.$emit('reset');
    },
    focus() {
      const { input } = this.$refs;
      if (input) input.focus();
    },
  },
});
</script>

<style scoped lang='scss'>
.filter-free-search {
  margin: 0;
}
.filter-text {
  width: 100%;
  min-height: 32px;
  position: relative;
  line-height: 22px;
  color: $blue;

  input {
    color: $blue;
    padding: 0 25px 0 7px;
    margin: 0 !important;
    height: 32px;
    font-size: 13px;
    font-family: $font-family-regular;
    border-color: $blue;

    &.fts-as-you-type.i-active-filter {
      background-color: $i-list-selected-bg;
    }
  }
  input::-ms-clear {
    display: none;
  }

  .btn-action {
    position: absolute;
    cursor: pointer;
    top: 0;
    right: 0;
    width: 30px;
    height: 100%;
    font-size: 15px;
    color: $blue;
    transition: opacity 0.6;
    &:hover {
      opacity: 0.9;
    }

    &:before {
      position: absolute;
      top: 50%;
      left: 50%;
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
    }
  }
}
</style>
